import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=bc5dc8cc&scoped=true"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"
import style0 from "./TransferForm.vue?vue&type=style&index=0&id=bc5dc8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc5dc8cc",
  null
  
)

export default component.exports